import { Button } from '@talentmesh/ui/components/button';
import { cn } from '@talentmesh/ui/lib/utils';
import { ChevronLeft } from 'lucide-react';
import { ReactElement } from 'react';
import ProcessingState from '@/Models/ProcessingState';
import UIStrings from '@/Utils/UIStrings';

export interface StepperNavigationButtonsProps {
    activeStep: number;
    handleBack?: () => void;
    nextButtonComponent: ReactElement | null;
    processingState: ProcessingState;
}

export const StepperNavigationButtons = ({
    activeStep,
    handleBack,
    nextButtonComponent,
    processingState,
}: StepperNavigationButtonsProps) => {
    return (
        <div className={cn('mt-8 flex flex-row items-center')}>
            {handleBack ? (
                <Button
                    type="button"
                    variant="outline"
                    size="default"
                    disabled={activeStep === 0 || processingState === ProcessingState.Processing}
                    onClick={handleBack}
                    className="gap-2"
                >
                    <ChevronLeft className="size-4 shrink-0" aria-hidden />
                    {UIStrings.Back}
                </Button>
            ) : null}
            <div className="min-w-0 flex-1" />
            {nextButtonComponent ?? null}
        </div>
    );
};
